import { useState, useCallback } from 'react';

/**
 * 조정금 상태 공통 훅.
 *
 * 모바일에서 '-' 입력이 까다로워 부호를 직접 받지 않는다.
 * 항상 양수를 입력받고 추가/할인 토글로 부호를 결정한다 (signed 로 노출).
 *
 * 사유(reason)도 여기서 들고 있다. 사유 입력칸은 조정금이 0이 아닐 때만 나타나므로
 * (AdjustmentInput) 평소에는 폼이 늘어나지 않는다.
 *
 * 되읽기도 여기서 담당한다. 조정금은 Jobs.priceBreakdown JSON 의 adjustment 에
 * 저장되므로(server/routes/jobs.js buildSnapshot) 잡을 다시 열 때 복원하지 않으면
 * 재저장 시 adjustmentAmount: 0 / adjustmentReason: '' 이 명시적으로 전송되어
 * 서버 폴백(routes/jobs.js:713-714)이 작동하지 못하고 할인과 사유가 사라진다.
 * 이 복원이 모달에만 빠져 있어 실제로 금액이 사라지는 버그가 있었다.
 */
const useAdjustment = () => {
    const [mode, setMode] = useState('add'); // 'add' | 'discount'
    const [amount, setAmount] = useState(''); // 항상 양수 문자열
    const [reason, setReason] = useState('');

    const signed = (parseFloat(amount) || 0) * (mode === 'discount' ? -1 : 1);

    // job 의 저장된 조정금으로 되돌린다. job 이 없으면(신규) 초기화.
    const reset = useCallback((job) => {
        let pb = job?.priceBreakdown;
        if (typeof pb === 'string') {
            try { pb = JSON.parse(pb); } catch (e) { pb = null; }
        }
        const adj = pb?.adjustment?.amount;
        if (adj != null && adj !== 0) {
            setMode(adj < 0 ? 'discount' : 'add');
            setAmount(String(Math.abs(adj)));
        } else {
            setMode('add');
            setAmount('');
        }
        setReason(pb?.adjustment?.reason || '');
    }, []);

    return { mode, setMode, amount, setAmount, reason, setReason, signed, reset };
};

export default useAdjustment;
